import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-java-collections',
  standalone: true,
  imports: [],
  templateUrl: './java-collections.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './java-collections.component.scss'
})
export class JavaCollectionsComponent {

}
